import axios from 'axios';
import * as actionTypes from './Actiontypes';

const BASE_URL = "https://api.happiclips.com/api"

export const create_event = (name, date, category_id) => {

    const payload = {
        name, date, category_id
    }
    return async (dispatch) => {
        dispatch({
            type: actionTypes.CREATE_EVENT_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/event/create`, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });

            dispatch({
                type: actionTypes.CREATE_EVENT_SUCCESS,
                payload: res.data,

            })
            return res.data;
        }
        catch (error) {
            dispatch({
                type: actionTypes.CREATE_EVENT_FAIL,
                payload: error
            })

        }
    }
}
export const get_event = () => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.VIEW_EVENT_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/events`, {}, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });

            dispatch({
                type: actionTypes.VIEW_EVENT_SUCCESS,
                payload: res.data
            })

        }
        catch (error) {
            dispatch({
                type: actionTypes.VIEW_EVENT_FAIL,
                payload: error
            })
        }
    }
}

export const delete_event = (id, payload) => {


    return async (dispatch) => {
        dispatch({
            type: actionTypes.DELETE_EVENT_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/event/delete/${id}`, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });

            dispatch({
                type: actionTypes.DELETE_EVENT_SUCCESS,
                payload: res.data,

            })
            // console.log(res.data)
        }
        catch (error) {
            dispatch({
                type: actionTypes.DELETE_EVENT_FAIL,
                payload: error
            })

        }
    }
}

export const update_event = (id, payload) => {

    return async (dispatch) => {
        dispatch({
            type: actionTypes.UPDATE_EVENT_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/event/update/${id}`, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
            dispatch({
                type: actionTypes.UPDATE_EVENT_SUCCESS,
                payload: res.data
            })

        }
        catch (error) {
            dispatch({
                type: actionTypes.UPDATE_EVENT_FAIL,
                payload: 'error'
            })
        }
    }

}
export const get_category = () => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.GET_CATEGORY_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/categories/all`, {}, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            }
            );
            dispatch({
                type: actionTypes.GET_CATEGORY_SUCCESS,
                payload: res.data
            })
            // console.log(res.data)
        }
        catch (error) {
            dispatch({
                type: actionTypes.GET_CATEGORY_FAIL,
                payload: error
            })
        }
    }
}

export const get_event_media = (eventId, page = 1) => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.GET_EVENT_MEDIA_INIT,
        });

        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.get(`${BASE_URL}/event/media/${eventId}?page=${page}&per_page=20`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            console.log("Payload: ", res.data)

            dispatch({
                type: actionTypes.GET_EVENT_MEDIA_SUCCESS,
                payload: res.data,
            });
            return res.data;
        } catch (error) {
            dispatch({
                type: actionTypes.GET_EVENT_MEDIA_FAIL,
                payload: error?.response?.data || error.message,
            });
        }
    };
};

export const upload_event_media = (eventId, mediaFiles) => {
    return async (dispatch) => {
        dispatch({ type: actionTypes.UPLOAD_EVENT_MEDIA_INIT });

        try {
            const authToken = localStorage.getItem('authToken');

            const formData = new FormData();
            formData.append('event_id', eventId);
            mediaFiles.forEach((file) => {
                formData.append('media[]', file);
            });

            const res = await axios.post(`${BASE_URL}/event/media/upload`, formData, {
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            dispatch({
                type: actionTypes.UPLOAD_EVENT_MEDIA_SUCCESS,
                payload: res.data,
            });

        } catch (error) {
            dispatch({
                type: actionTypes.UPLOAD_EVENT_MEDIA_FAIL,
                payload: error.response?.data || error.message,
            });
        }
    };
};

export const delete_event_media = (eventId, mediaId) => {
    return async (dispatch) => {
        dispatch({ type: actionTypes.DELETE_EVENT_MEDIA_INIT });

        try {
            const authToken = localStorage.getItem('authToken');

            const res = await axios.delete(`${BASE_URL}/event/media/${eventId}/${mediaId}`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            dispatch({
                type: actionTypes.DELETE_EVENT_MEDIA_SUCCESS,
                payload: {
                    mediaId,
                    message: res.data?.message,
                },
            });

        } catch (error) {
            dispatch({
                type: actionTypes.DELETE_EVENT_MEDIA_FAIL,
                payload: error?.response?.data || error.message,
            });
        }
    };
};
